import PropTypes from 'prop-types';
import OutOfTheOfficeStatusRecord from '../records/OutOfTheOfficeStatusRecord';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function OutOfTheOfficeAlert({
  name,
  outOfTheOffice
}) {
  return /*#__PURE__*/_jsxs(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "out-of-the-office-warning",
      message: "app.outOfTheOffice.warning",
      options: {
        name
      }
    }),
    type: "warning",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.outOfTheOffice.back"
    }), /*#__PURE__*/_jsx(FormattedDateTime, {
      format: "dddd, LL",
      value: outOfTheOffice.untilMillis
    })]
  });
}
OutOfTheOfficeAlert.propTypes = {
  name: PropTypes.string.isRequired,
  outOfTheOffice: PropTypes.instanceOf(OutOfTheOfficeStatusRecord).isRequired
};
export default OutOfTheOfficeAlert;